import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { getTotal, getItemsCount } from '../../store/cart'
import { toggleCart, getCurrencySign } from '../../store/common'
import { getTranslate } from 'react-localize-redux'

const CartInHeader = ({
  toggleCart,
  getItemsCount,
  getTotal,
  currencySign,
  isCartOpen,
  translate
}) => {
  return (
    <div
      className={'header__cart ' + (isCartOpen ? 'open' : null)}
      onClick={toggleCart}
    >
      <div><i className='fa fa-fw fa-shopping-cart' /></div>
      {getItemsCount
        ? <div className='header__cart__sum'>
          <span>{getItemsCount} {getItemsCount === 1 ? translate('molecules.containers.cartInHeaders.item') : translate('molecules.containers.cartInHeaders.items')}</span>
          <span>{getTotal} {currencySign}</span>
        </div>
        : <div className='header__cart__sum'>
          <span>{translate('molecules.containers.cartInHeaders.no_items')}</span><span>0.00 {currencySign}</span>
        </div>}
    </div>
  )
}

CartInHeader.propTypes = {
  toggleCart: PropTypes.func.isRequired,
  getItemsCount: PropTypes.string,
  getTotal: PropTypes.number,
  currencySign: PropTypes.string,
  isCartOpen: PropTypes.bool,
  translate: PropTypes.func
}

const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
  getTotal: getTotal(state.cart.list, state.common.user.shippingPrice),
  getItemsCount: getItemsCount(state.cart.list),
  currencySign: getCurrencySign(state.common.user.currency.sign),
  isCartOpen: state.common.cartOpen,
})

const mapDispatchToProps = (dispatch) => ({
  toggleCart: () => dispatch(toggleCart()),
})

export default connect(mapStateToProps, mapDispatchToProps)(CartInHeader)



// WEBPACK FOOTER //
// ./src/molecules/containers/CartInHeader.js